var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apexchart',{ref:"barChart",attrs:{"type":"bar","options":_vm.apexOptions,"series":_vm.series}})
}
var staticRenderFns = []

export { render, staticRenderFns }